export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_fragment_1.39a4041e.jpg";